import { Child } from './child.model';
export class Cart {
    productId: string;
    INTsku: string;
    qty: number;
    product: Child;
    userId: string;
    items: string;
    confirmationItemStatus: string;
}
